<template>
  <div class="section">
    <div class="columns is-centered">
      <div
        class="column is-full-mobile is-8-tablet is-5-desktop is-3-widescreen is-3-fullhd"
        style="text-align: center"
      >
        <h1 class="title is-4">Anmelden</h1>
        <div class="block" v-if="error">
          <b-message type="is-danger">
            {{ error }}
          </b-message>
        </div>
        <div class="block">
          <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
            <div
              v-on:keyup.enter="handleSubmit(submit)"
              style="text-align: left"
            >
              <div class="block">
                <BInputWithValidation
                  rules="required|email"
                  type="email"
                  label="E-Mail"
                  v-model="data.email"
                />
              </div>

              <div class="block" style="margin-bottom: 1rem">
                <BInputWithValidation
                  rules="required"
                  type="password"
                  label="Passwort"
                  vid="password"
                  v-model="data.password"
                />
              </div>
              <div class="block" style="margin-bottom: 1.2rem">
                <BCheckboxesWithValidation label="Angemeldet bleiben">
                  <b-checkbox v-model="data.remember">
                    Anmeldedaten speichern
                  </b-checkbox>
                </BCheckboxesWithValidation>
              </div>

              <div class="block">
                <b-button
                  type="is-outlined is-gold"
                  expanded
                  :disabled="invalid"
                  :loading="loading"
                  @click="handleSubmit(submit)"
                >
                  Anmelden
                </b-button>
              </div>
            </div>
          </ValidationObserver>
        </div>
        <div class="block">
          <b-button
            expanded
            type="is-text"
            tag="router-link"
            :to="{ name: 'PasswordRequest' }"
          >
            Passwort vergessen?
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import BInputWithValidation from '@/components/inputs/BInputWithValidation.vue';
import BCheckboxesWithValidation from '@/components/inputs/BCheckboxesWithValidation.vue';

export default {
  name: 'Home',
  components: {
    BInputWithValidation,
    BCheckboxesWithValidation,
  },
  data() {
    return {
      data: {
        email: '',
        password: '',
        remember: true,
      },
    };
  },
  computed: mapGetters({ loading: 'auth/loading', error: 'auth/error' }),
  methods: {
    submit() {
      this.$store.dispatch('auth/LOGIN', this.data);
    },
  },
};
</script>
